import ButtonDropdown from '@rio-cloud/rio-uikit/components/dropdown/ButtonDropdown';
import DateTimeOrNoData from 'features/vehicle-key-data/DateTimeOrNoData';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    ActiveSidebar,
    getActiveSidebar,
    getSelectedTeam,
    setSelectedTeam,
    setTeamDialog,
} from 'store/slices/settingsPageSlice';

import Can from '../../../components/auth/Can';

import type { SystemTeam } from 'API';

interface TeamSettingsRowProps {
    team: SystemTeam;
}

const TeamSettingsRow = ({ team }: TeamSettingsRowProps) => {
    const dispatch = useDispatch();
    const selectedTeam = useSelector(getSelectedTeam);
    const activeSidebar = useSelector(getActiveSidebar);
    const isActive = selectedTeam?.id === team.id && activeSidebar === ActiveSidebar.TEAMS;

    const selectTeam = (event: Event) => {
        const element = event.target as HTMLInputElement;
        const elementTestId = element.getAttribute('data-testid');
        if (elementTestId && elementTestId.includes('system-teams-row-info')) {
            dispatch(setSelectedTeam(team));
        }
    };

    const openTeamDialog = () => {
        dispatch(setTeamDialog({ team, showTeamDialog: true }));
    };

    const dropdownItems = [
        {
            value: (
                <span className='TeamRow__dropdownItems'>
                    <span className='rioglyph rioglyph-pencil TeamRow__dropdownItemIcons' />
                    <p className='TeamRow__dropdownItemIcons'>Edit</p>
                </span>
            ),
            onSelect: () => openTeamDialog(),
        },
    ];

    useEffect(() => {
        const element = document.getElementById(team.id);
        if (element) {
            element.addEventListener('click', selectTeam);
            return () => {
                element.removeEventListener('click', selectTeam);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, selectTeam]);

    return (
        <tr id={team.id} className={`cursor-pointer align-items-center ${isActive && 'active'}`}>
            <td data-testid='system-teams-row-info-firstName'>{team.name}</td>
            <td data-testid='system-teams-row-info-lastName'>{team.numberOfUsers}</td>
            <td data-testid='system-teams-row-info-email'>{team.numberOfFleets}</td>
            <td data-testid='system-teams-row-info-phone'>
                <DateTimeOrNoData value={team.createdAt} />
            </td>
            <td
                className='TeamRow__iconColumn'
                data-testid='system-teams-row-dropdown-icon'
                onClick={e => e.stopPropagation()}
            >
                <Can type='teams' action='edit'>
                    <ButtonDropdown
                        title={<span className='rioglyph rioglyph-option-vertical TeamRow__dropdown' />}
                        items={dropdownItems}
                        bsStyle='muted'
                        iconOnly
                        dropup
                        noCaret
                        className='TeamRow__dropdownButton'
                    />
                </Can>
            </td>
        </tr>
    );
};

export default TeamSettingsRow;
